import { LayoutGrid } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useAuthStore } from '@/store/auth.store';
import { SOFT_ACCENT_MARK_CLASS } from '@/styles/accentMark';

interface NavEmptyNoteProps {
  searchText: string;
  className?: string | undefined;
}

export function NavEmptyNote({ searchText, className }: NavEmptyNoteProps) {
  const arePermissionsLoaded = useAuthStore((state) => state.arePermissionsLoaded);

  if (searchText.trim() !== '') {
    return (
      <p className={cn('px-2.5 py-6 text-center text-sm text-muted-foreground', className)}>
        No menu matches &ldquo;{searchText}&rdquo;
      </p>
    );
  }

  if (!arePermissionsLoaded) return null;

  return (
    <div className={cn('flex flex-col items-center gap-2 px-2.5 py-6 text-center', className)}>
      <span
        className={cn(
          'flex size-10 items-center justify-center rounded-xl',
          SOFT_ACCENT_MARK_CLASS,
        )}
      >
        <LayoutGrid className="size-5" aria-hidden />
      </span>
      <p className="text-sm font-semibold text-foreground">No pages yet</p>
      <p className="text-xs text-muted-foreground">Ask your admin to give you access.</p>
    </div>
  );
}
